module.exports = __webpack_public_path__ + "img/tt.cd99330e.svg";